import React, { useState } from "react";
import {
  Button,
  Typography,
  Grid,
  TextField,
  Box,
  Tabs,
  Tab,
} from "@material-ui/core";
import PropTypes from "prop-types";
import useStyles from "./styles";
import ModalCheckin from './components/ModalCheckin';
import StatusProgress from "./components/StatusProgress";
import FieldData, { FieldDataInnerField } from "./components/FieldData";
import Confirm from "../Confirm";
import ConfirmReason from "../ConfirmReason";
import { prettyDate, prettyDateTime } from "../../utils/date";
import SearchIcon from "@material-ui/icons/Search";
import { createGetQueryToken } from "../../api/api-client";
import { usePermissions } from "../../utils/permissions";
import { UserGroups, schedulingStatus } from '../../utils/constants';
import { downloadResume } from '../../api/scheduling';

const translate = {
  "driver document": "CNH do motorista",
  "scheduling document": "Nota fiscal",
  "truck document": "Documento Caminhão",
};

const SchedulingStatusComponent = ({
  onBackToList,
  enableCalled,
  enableSendTruck,
  schedulingData,
  startProcess,
  setDriverCheckin,
  setRDS,
  cancelProcess,
  callProcess,
  finishProcess,
  setAdditionalInfoCalled,
  handleMonitorOpen
}) => {
  const classes = useStyles();

  const [isOpenFinish, setOpenFinish] = useState(false);
  const [isOpenDriverCheckin, setOpenDriverCheckin] = useState(false);
  const [isOpenStart, setOpenStart] = useState(false);
  const [isOpenRDS, setOpenRDS] = useState(false);
  const [isOpenCancel, setOpenCancel] = useState(false);
  const [isOpenCall, setOpenCall] = useState(false);
  const [isOpenModalCheckin, setOpenModalCheckin] = useState(false);
  const [RDSNumber, setRDSNumber] = useState("");
  const { scheduling: schedulingPermissions, hasGroup } = usePermissions();

  const a11yProps = (index) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });

  const handleOpenStart = () => {
    setOpenStart(true);
  };

  const handleCancel = () => {
    setOpenCancel(true);
  };

  const handleModalStartClose = async (confirm) => {
    if (confirm) {
      await startProcess(schedulingData.id);
      setOpenRDS(true);
    }
    setOpenStart(false);
  };

  const handleModalCancelClose = async (confirm, reason) => {
    if (confirm) {
      await cancelProcess(schedulingData.id, reason);
    }
    setOpenCancel(false);
  };

  const handleModalCallClose = async (confirm) => {
    if (!confirm) {
      setOpenCall(false);
      return;
    }

    await callProcess(schedulingData.id);
    setOpenCall(false);
  };


  const handleOpenDriverCheckin = () => {
    setOpenDriverCheckin(true);
  };

  const handleOpenFinish = () => {
    setOpenFinish(true);
  };

  const handleModalRDSClose = async (confirm) => {
    if (confirm) {
      await setRDS({ id: schedulingData.id, RDSNumber });
      setRDSNumber("");
    }
    setOpenRDS(false);
  };

  const handleModalDriverCheckinClose = async (confirm) => {
    if (confirm) {
      if (enableCalled) {
        setOpenModalCheckin(true);
      } else {
        await setDriverCheckin(schedulingData.id);
      }
    }

    setOpenDriverCheckin(false);
  };

  const handleConfirmDriverInfo = async (payload) => {
    setAdditionalInfoCalled({ ...payload, id: schedulingData.id })
  }

  const handleModalFinishClose = async (confirm) => {
    if (confirm) {
      await finishProcess(schedulingData.id);
    }
    setOpenFinish(false);
  };

  const cantCancell = () =>
    !!schedulingData.ended_date || !!schedulingData.cancelled_date;
  const cantCall = () =>
    schedulingData.id_scheduling_status !== schedulingStatus.fila.id;
  const cantCallAgain = () =>
    schedulingData.id_scheduling_status !== schedulingStatus.chamado.id;
  const cantDoCheckin = () =>
    !!schedulingData.driver_checkin_date || cantCancell() || (schedulingData.id_scheduling_status === schedulingStatus.atrasado.id && hasGroup(UserGroups.checkinAgent));
  const cantDoStart = () =>
    !schedulingData.driver_checkin_date ||
    !!schedulingData.started_date ||
    (enableCalled && !schedulingData.called_at) ||
    cantCancell();
  const cantFinish = () =>
    !schedulingData.started_date ||
    !!schedulingData.ended_date ||
    cantCancell();

  return schedulingData && Object.keys(schedulingData).length ? (
    <div className={classes.TabNavigationCtrlFilterPanel}>
      <div className={classes.navigation}>
        <Grid container spacing={3}>
          <Grid item md={3} xs={12}>
            <div>
              <Tabs
                TabIndicatorProps={{
                  style: {
                    height: "6px",
                    backgroundColor: "#658D1B",
                  },
                }}
                className={classes.navigationRoutesTabs}
                value={0}
              >
                <Tab
                  className={classes.navigationRoutesTabsTab}
                  key={1}
                  label={`Status`}
                  {...a11yProps(0)}
                />
              </Tabs>
            </div>
          </Grid>
          <Grid item md={9} xs={12}>
            <div className={classes.navigationControls}>
              <div className={classes.containerButtons}>
                <Button
                  size="large"
                  color='primary'
                  variant='contained'
                  onClick={() => downloadResume(schedulingData.id)}
                  className={classes.downloadButton}
                  id={`scheduling-status-component-button-print-id`}
                  data-cy={`scheduling-status-component-button-print-data-cy`}
                >
                  Imprimir PDF
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  className={classes.backButton}
                  onClick={onBackToList}
                  id={`scheduling-status-component-button-back-id`}
                  data-cy={`scheduling-status-component-button-back-data-cy`}
                >
                  Voltar
                </Button>
              </div>

              {schedulingPermissions.canCheckin && (
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  disabled={cantDoCheckin()}
                  className={classes.addButton}
                  onClick={handleOpenDriverCheckin}
                  id={`scheduling-status-component-button-info-id`}
                  data-cy={`scheduling-status-component-button-info-data-cy`}
                >
                  Informar chegada do motorista
                </Button>
              )}
              {enableCalled && schedulingPermissions.canCall && !cantCall() && (
                <>
                  <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    disabled={cantCall()}
                    className={classes.addButton}
                    onClick={handleMonitorOpen}
                    id={`scheduling-status-component-button-call-id`}
                    data-cy={`scheduling-status-component-button-call-data-cy`}
                  >
                    Chamar Agendamento
                  </Button>
                </>
              )}
              {enableCalled && schedulingPermissions.canCall && !cantCallAgain() && (
                <>
                  <Button
                    color="primary"
                    variant="contained"
                    size="large"
                    disabled={cantCallAgain()}
                    className={classes.addButton}
                    onClick={handleMonitorOpen}
                    id={`scheduling-status-component-button-again-id`}
                    data-cy={`scheduling-status-component-button-again-data-cy`}
                  >
                    Chamar Novamente
                  </Button>
                </>
              )}
              {schedulingPermissions.canStart && (
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  disabled={cantDoStart()}
                  className={classes.addButton}
                  onClick={handleOpenStart}
                  id={`scheduling-status-component-button-start-id`}
                  data-cy={`scheduling-status-component-button-start-data-cy`}
                >
                  Iniciar Atendimento
                </Button>
              )}
              {schedulingPermissions.canFinish && (
                <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  disabled={cantFinish()}
                  className={classes.addButton}
                  onClick={handleOpenFinish}
                  id={`scheduling-status-component-button-end-id`}
                  data-cy={`scheduling-status-component-button-end-data-cy`}
                >
                  Finalizar Atendimento
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
      <Box height="100%" className={classes.containers}>
        <div className={classes.headers}>
          <Typography variant="h4">
            DATA: <span>{prettyDate(schedulingData.scheduling_date)}</span>
          </Typography>
          <Typography variant="h4">{schedulingData.load_type}</Typography>
          <Typography variant="h4">
            Nº agendamento:{" "}
            <span className="schudulingNumber">{schedulingData.id}</span>
          </Typography>
        </div>
        <div>
          <StatusProgress
            listStatus={[
              {
                title: "Agendado",
                subtitle: `${schedulingData.block_name} ${schedulingData.block_start} ~ ${schedulingData.block_end}`,
                completed: true,
              },
              {
                title: "Chegada ao Local",
                subtitle: schedulingData.driver_checkin_date
                  ? prettyDateTime(schedulingData.driver_checkin_date)
                  : "",
                completed: !!schedulingData.driver_checkin_date,
              },
              {
                  title: "Agendamento Chamado",
                  subtitle: schedulingData.called_at
                  ? prettyDateTime(schedulingData.called_at)
                  : "",
                  completed: !!schedulingData.called_at,
                  notShow: !enableCalled
               },
               {
                  title: "Em Trânsito",
                  subtitle: schedulingData.started_transit_in
                    ? prettyDateTime(schedulingData.started_transit_in)
                    : "",
                  completed: !!schedulingData.started_transit_in,
                  notShow: !enableSendTruck
               },
              {
                title: "Atendimento",
                subtitle: schedulingData.started_date
                  ? prettyDateTime(schedulingData.started_date)
                  : "",
                completed: !!schedulingData.started_date,
              },
              {
                title: !!schedulingData.cancelled_date
                  ? "Cancelado"
                  : "Finalizado!",
                subtitle: schedulingData.cancelled_date
                  ? prettyDateTime(schedulingData.cancelled_date)
                  : schedulingData.ended_date
                    ? prettyDateTime(schedulingData.ended_date)
                    : "",
                completed:
                  schedulingData.cancelled_date || !!schedulingData.ended_date,
              },
            ]}
            currentStatus="Agendado"
          />
        </div>
        <Grid container spacing={3}>
          <Grid item md={6} xs={12}>
            <FieldData label="Cliente/Fornecedor/Produtor">
              {schedulingData.client_name}
            </FieldData>
            <FieldData label="Unidade Cargill">
              {schedulingData.branch_name} / {schedulingData.plant_name}
            </FieldData>
            <FieldData label="Nome do Motorista">
              {schedulingData.driver_name ?? "--"}
            </FieldData>
            <FieldData label="Documentos">
              {schedulingData.files.length ? (
                schedulingData.files.map((file, index) => (
                  <FieldDataInnerField
                    key={index}
                    label={translate[file.file_type]}
                  >
                    <a
                      href={createGetQueryToken(
                        "v1/Schedulings/file",
                        `key=${file.file_key}`
                      )}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={classes.fileLink}
                    >
                      <span>{file.file_key}</span>
                      <Button
                        data-cy="search-button"
                        id="search-button"
                        size="small" color="primary" variant="contained">
                        <SearchIcon />
                      </Button>
                    </a>
                  </FieldDataInnerField>
                ))
              ) : (
                  <p>Não há arquivos anexados.</p>
                )}
            </FieldData>
          </Grid>
          <Grid item md={6} xs={12} className={classes.gridDouble}>
            <Grid container>
              <Grid item md={6} xs={12}>
                <FieldData label="CNPJ/CPF  Cliente/Fornecedor/Produtor">
                  {schedulingData.client_document}
                </FieldData>
              </Grid>
              <Grid item md={6} xs={12}>
                <FieldData label="Número da NF / Número de Série">
                  {schedulingData.document_number} /{" "}
                  {schedulingData.serial_number}
                </FieldData>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={6} xs={12}>
                <FieldData label="Produto">{schedulingData.product}</FieldData>
              </Grid>
              <Grid item md={6} xs={12}>
                <FieldData label="Volume">{schedulingData.volume}</FieldData>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={6} xs={12}>
                <FieldData label="Número da CNH do motorista">
                  {schedulingData.driver_document ?? "--"}
                </FieldData>
              </Grid>
              <Grid item md={6} xs={12}>
                <FieldData label="Placa do caminhão">
                  {schedulingData.truck_plate}
                </FieldData>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md={6} xs={12}>
                <FieldData label="CNPJ Transportadora">
                  {schedulingData.transporter_document ?? "--"}
                </FieldData>
              </Grid>
              <Grid item md={6} xs={12}>
                <FieldData label="Número da FICHA RDS">
                  {schedulingData.rds_id ?? "--"}
                </FieldData>
              </Grid>
            </Grid>
            {!!schedulingData.cancelled_reason && (
              <Grid item xs={12}>
                <FieldData label="Motivo do cancelamento">
                  {schedulingData.cancelled_reason}
                </FieldData>
              </Grid>
            )}
            <div className={classes.controls}>
              {schedulingPermissions.canCancel && (
                <Button
                  variant="contained"
                  size="large"
                  data-cy="cancel-button"
                  id="cancel-button"
                  disabled={cantCancell() || !([schedulingStatus.agendado.id, schedulingStatus.reagendado.id, schedulingStatus.fila.id, schedulingStatus.atrasado.id].indexOf(schedulingData.id_scheduling_status) !== -1)}
                  className={classes.cancelButton}
                  onClick={handleCancel}
                >
                  Cancelar
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </Box>
      <Confirm
        isOpen={isOpenDriverCheckin}
        title="Confirma a chegada do motorista?"
        okText="Sim"
        data-cy="checking-modal"
        id="checking-modal"
        cancelText="Cancelar"
        handleClose={handleModalDriverCheckinClose}
      />
      <Confirm
        isOpen={isOpenFinish}
        title="Deseja finalizar o atendimento?"
        okText="Sim"
        data-cy="finalize-modal"
        id="finalize-modal"
        cancelText="Cancelar"
        handleClose={handleModalFinishClose}
      />
      <Confirm
        isOpen={isOpenStart}
        title="Deseja iniciar o atendimento?"
        okText="Sim"
        data-cy="start-modal"
        id="start-modal"
        cancelText="Cancelar"
        handleClose={handleModalStartClose}
      />
      <ConfirmReason
        isOpen={isOpenCancel}
        title="Confirma cancelamento deste agendamento?"
        okText="Sim"
        data-cy="reason-modal"
        id="reason-modal"
        placeholder="Motivo do cancelamento (obrigatório)"
        cancelText="Não"
        handleClose={handleModalCancelClose}
      />
      <Confirm
        isOpen={isOpenCall}
        title="Confirma chamado?"
        okText="Sim"
        cancelText="Não"
        data-cy="confirm-modal"
        id="confirm-modal"
        handleClose={handleModalCallClose}
      />
      <Confirm
        isOpen={isOpenRDS}
        title="Atendimento Iniciado. Informe o número da ficha RDS para o atendimento"
        okText="Confirmar"
        data-cy="rds-modal"
        id="rds-modal"
        cancelText="Não tenho interesse"
        handleClose={handleModalRDSClose}
      >
        <Box m={2}>
          <TextField
            className={classes.inputRDS}
            value={RDSNumber}
            label="Número RDS"
            data-cy="rds-field"
            id="rds-field"
            onChange={(event) => setRDSNumber(event.currentTarget.value)}
            style={{ width: "100%" }}
            variant="outlined"
          />
        </Box>
      </Confirm>

      <ModalCheckin
        open={isOpenModalCheckin}
        data-cy="checking-modal-2"
        id="checking-modal-2"
        hasQueueOrder={schedulingData?.branch_config?.enable_called_queue_order}
        onClose={() => setOpenModalCheckin(false)}
        onConfirm={handleConfirmDriverInfo}
      />
    </div>
  ) : (
      <div className={classes.noContent}>
        <Typography variant="h5">Dados não encontrados!</Typography>
        <Button
          color="primary"
          variant="contained"
          size="large"
          data-cy="back-button"
          id="back-button"
          onClick={onBackToList}
        >
          Voltar a lista
      </Button>
      </div>
    );
};

SchedulingStatusComponent.propTypes = {
  onBackToList: PropTypes.func.isRequired,
  enableCalled: PropTypes.bool.isRequired,
  schedulingData: PropTypes.object.isRequired,
  setRDS: PropTypes.func,
  startProcess: PropTypes.func,
  finishProcess: PropTypes.func,
  setDriverCheckin: PropTypes.func,
  setAdditionalInfoCalled: PropTypes.func,
  cancelProcess: PropTypes.func,
};

export default SchedulingStatusComponent;
